import groupBy from '@/utils/groupBy';
import { useMemo } from 'react';
import { isToday } from 'date-fns/isToday';
import { parse } from 'date-fns/parse';

export interface HookProps {
  items: WeekdayMealTypeEntity[];
}

export function useTodayReserve({
  items
}: HookProps) {

  const { currentUserReserve, currentUserMealTypes, teammateMealTypes, teammatesReserve } = useMemo(() => {
    const teammateMealTypes: WeekdayMealTypeEntity[] = [];
    const currentUserMealTypes: WeekdayMealTypeEntity[] = [];
    for (const item of items) {
      if (item.date) {
        const itemDate = parse(item.date, 'yyyy-MM-dd', new Date());
        if (item.teammateReserve) {
          if (isToday(itemDate)) {
            teammateMealTypes.push(item);
          }
        }
        else {
          if (isToday(itemDate)) {
            currentUserMealTypes.push(item);
          }
        }
      }
    }

    const currentUserReserves = [];
    const teammateReserves = [];
    for (const mealType of teammateMealTypes) {
      teammateReserves.push(mealType.teammateReserve);
    }

    for (const mealType of currentUserMealTypes) {
      currentUserReserves.push(mealType.reserve);
    }

    const teammatesReserve = groupBy<Record<string, ReserveReportItem[]>>(teammateReserves, 'username');
    const currentUserReserve = groupBy<Record<string, ReserveReportItem[]>>(currentUserReserves, 'username');
    return {
      teammateMealTypes,
      teammatesReserve,
      currentUserReserve,
      currentUserMealTypes,
    };
  }, [items]);

  const currentUserReservesCount = useMemo(() => {
    const result = {};
    Object.keys(currentUserReserve).forEach(key => {
      result[key] = 0;
      currentUserReserve[key].forEach(item => {
        result[key] += (item?.selectedCount || 0);
      });
    });
    return result;
  }, [currentUserReserve]);

  const teammatesReservesCount = useMemo(() => {
    const result = {};
    Object.keys(teammatesReserve).forEach(key => {
      result[key] = 0;
      teammatesReserve[key].forEach(item => {
        result[key] += (item?.selectedCount || 0);
      });
    });
    return result;
  }, [teammatesReserve]);

  return {
    teammateMealTypes,
    teammatesReserve,
    teammatesReservesCount,
    currentUserMealTypes,
    currentUserReserve,
    currentUserReservesCount
  };

}

export default useTodayReserve;
